import { Box, Group } from "@repo/ui/core";
import { TeamCard } from "@components/TeamCard";
import { useCustomerData } from "@contexts/CustomerContext";

export function TeamSlide() {
  const { team } = useCustomerData();

  return (
    <Box w="100%" maw={1400}>
      <Group justify="center" gap={80}>
        {team.map((member) => (
          <TeamCard key={member.name} member={member} />
        ))}
      </Group>
    </Box>
  );
}
